import { css } from '@emotion/css';
import accountStyles from './account-option.style';
import userApi from 'apis/userApi';
import toast from 'react-hot-toast';
import moment from 'moment';
import LoadingIcon from 'components/loading/LoadingIcon';
import { UserInfoModel } from 'models/userInfoModel';
import { useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';

const orderMemberList = [
    { value: 0, label: 'Thời gian đăng ký mới nhất' },
    { value: 1, label: 'Thời gian đăng ký cũ nhất' },
    { value: 2, label: 'Số dư ít nhất' },
    { value: 3, label: 'Số dư nhiều nhất' },
    { value: 4, label: 'Đăng nhập nhiều nhất' },
    { value: 5, label: 'Đăng nhập gần đây nhất' },
];

interface MemberItem extends UserInfoModel {
    isShow?: boolean;
    pointsscDisplay?: string;
}

function AgentMember() {
    const navigate = useNavigate();

    // Form state - dùng useState như các component khác trong project
    const [loginname, setLoginname] = useState('');
    const [orderData, setOrderData] = useState(0);
    const [samount, setSamount] = useState('');
    const [eamount, setEamount] = useState('');

    // Data state
    const [memberList, setMemberList] = useState<MemberItem[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [showLoadMore, setShowLoadMore] = useState(false);
    const aBalance = useRef(0);

    const updateRecordList = (list: UserInfoModel[]): MemberItem[] => {
        return list.map((item) => {
            const pointsscDisplay = item.pointssc !== 0
                ? (item.pointssc * 100).toFixed(1)
                : '0';
            return {
                ...item,
                isShow: false,
                pointsscDisplay,
            };
        });
    };

    const getData = async (action: 'btnSearch' | 'nextPage') => {
        const payload = {
            loginname,
            samount: samount.replace(/,/g, ''),
            eamount: eamount.replace(/,/g, ''),
            order: orderData,
            userarea: 0,
        };

        setLoading(true);
        try {
            const { data } = await userApi.agentUserSearch(action, payload);
            if (!data.msg) {
                aBalance.current = Number(data.abalance || 0);
                const newList = updateRecordList(data.reslist);

                if (action === 'btnSearch') {
                    setMemberList(newList);
                    setShowLoadMore(newList.length < data.totalrecord);
                } else {
                    setMemberList((prevList) => {
                        const combinedList = [...(prevList || []), ...newList];
                        setShowLoadMore(combinedList.length < data.totalrecord);
                        return combinedList;
                    });
                }
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        getData('btnSearch');
    };

    const loadMoreRecord = () => {
        getData('nextPage');
    };

    return (
        <>
            <div className={`${accountStyles.wrap}`}>
                <h6 className={accountStyles.title}>Cấp Dưới</h6>
                <div className={accountStyles.flexbox}>
                    <div className={`${accountStyles.groupInput} ${styles.flex30}`}>
                        <label htmlFor="">Tên Đăng Nhập</label>
                        <div className={accountStyles.wrapInput}>
                            <input
                                value={loginname}
                                onChange={(e) => setLoginname(e.target.value)}
                                className="input-common"
                                type="text"
                                placeholder="Từ 5 đến 30 ký tự và không chứa khoảng trắng"
                            />
                        </div>
                    </div>
                    <div className={`${accountStyles.groupInput} ${styles.flex30}`}>
                        <label htmlFor="">Sắp Xếp Theo</label>
                        <div className={accountStyles.wrapInput}>
                            <select className="input-common" value={orderData} onChange={(e) => setOrderData(Number(e.target.value))}>
                                {orderMemberList.map((item) => (
                                    <option value={item.value} key={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className={`${styles.flex40} ${styles.groupAmount}`}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Số Dư Từ</label>
                            <div className={accountStyles.wrapInput}>
                                <NumericFormat
                                    className="input-common"
                                    thousandSeparator=","
                                    value={samount}
                                    onChange={(e) => setSamount(e.target.value)}
                                    placeholder="Số dư từ"
                                />
                            </div>
                        </div>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Đến</label>
                            <div className={accountStyles.wrapInput}>
                                <NumericFormat
                                    className="input-common"
                                    thousandSeparator=","
                                    value={eamount}
                                    onChange={(e) => setEamount(e.target.value)}
                                    placeholder="Số dư đến"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.elmSubmit}`}>
                    <button type="button" className={`btn-primary ${accountStyles.btnSubmit}`} onClick={handleSearch}>
                        Tìm Kiếm
                    </button>
                </div>

                <div className="table-common">
                    {memberList ? (
                        <>
                            {memberList.length > 0 ? (
                                memberList.map((mem) => (
                                    <div
                                        className={`col-table ${styles.memberItem}`}
                                        key={mem.id}
                                    >
                                        <div className="col-header">
                                            <p>{mem.loginname}</p>
                                            <span>
                                                {new Intl.NumberFormat().format(Number(mem.balance) || 0)} [{mem.pointsscDisplay}%]
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <p>Ngày đăng ký:</p>
                                                <strong>{moment(mem.addtime).format('DD/MM/yyyy HH:mm')}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Số dư:</p>
                                                <strong>{new Intl.NumberFormat().format(Number(mem.balance))}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Lần đăng nhập:</p>
                                                <strong>{mem.logintimes}</strong>
                                            </div>
                                            <div className="col">
                                                <p>Đăng nhập cuối:</p>
                                                <strong>
                                                    {mem.lastlogintime
                                                        ? moment(mem.lastlogintime).format('DD/MM/yyyy HH:mm')
                                                        : 'Chưa đăng nhập lần nào'}
                                                </strong>
                                            </div>
                                            <div className="col">
                                                <p>Cấp trên:</p>
                                                <strong>{mem.param2}</strong>
                                            </div>
                                        </div>
                                        <div className={styles.buttonGroup} onClick={(e) => e.stopPropagation()}>
                                            <button
                                                type="button"
                                                className={styles.btnBalance}
                                                onClick={() => navigate('/account?mode=fund-tran')}
                                            >
                                                Biến động số dư
                                            </button>
                                            <button
                                                type="button"
                                                className={styles.btnStats}
                                                onClick={() => navigate('/account?mode=agent-team-balance', {
                                                    state: { id: mem.id, loginname: mem.loginname, nickname: mem.nickname }
                                                })}
                                            >
                                                Thống kê nhóm
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-data">
                                    <img src={require('assets/images/icons/no-data.png')} alt="" />
                                    <p>Không có dữ liệu</p>
                                </div>
                            )}

                            {showLoadMore && (
                                <div className={styles.loadMoreWrap}>
                                    <button
                                        type="button"
                                        className="btn-primary"
                                        onClick={loadMoreRecord}
                                        disabled={loading}
                                    >
                                        {loading ? 'Đang tải...' : 'Tải thêm'}
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="no-data">
                            <img src={require('assets/images/icons/no-data.png')} alt="" />
                            <p>Không có dữ liệu</p>
                        </div>
                    )}
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    groupAmount: css`
        display: flex;
        gap: 12px;
    `,
    flex30: css`
        flex: 0 0 calc(30% - 32px);
    `,
    flex40: css`
        flex: 0 0 calc(40% - 32px);
    `,
    elmSubmit: css`
        max-width: 40%;
        margin: 15px auto;
    `,
    memberItem: css`
        position: relative;
        transition: all 0.25s ease;

        &:hover {
            background: rgba(0, 0, 0, 0.02);
        }
    `,
    buttonGroup: css`
        display: flex;
        gap: 10px;
        justify-content: center;
        padding: 5px;
    `,
    btnBalance: css`
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 13px;
        cursor: pointer;
        border: none;
        background: #e3f2fd;
        color: #1565c0;
        transition: all 0.2s ease;
        width: 30%;

        &:hover {
            background: #bbdefb;
        }
    `,
    btnStats: css`
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 13px;
        cursor: pointer;
        border: none;
        background: #e8f5e9;
        color: #2e7d32;
        transition: all 0.2s ease;
        width: 30%;

        &:hover {
            background: #c8e6c9;
        }
    `,
    loadMoreWrap: css`
        display: flex;
        justify-content: center;
        padding: 16px 0;

        button {
            padding: 10px 30px;
            border-radius: 8px;
            cursor: pointer;

            &:disabled {
                opacity: 0.7;
                cursor: not-allowed;
            }
        }
    `,
};

export default AgentMember;
